import { SKILLS, WORK } from './content'

/* The work history sits on the about page, under the bio. It keeps the
   sec-work id because the terminal's `work` link points at it. */
export function WorkSection() {
  return (
    <section className="sec" id="sec-work">
      <h2 className="sec__label">work</h2>
      <div className="jobs">
        {WORK.map((j) => (
          <article className="job rv" key={j.what}>
            <div className="job__when">{j.when}</div>
            <div>
              <h3>{j.what}</h3>
              <p>{j.body}</p>
              <div className="stack">{j.stack}</div>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export function StackSection() {
  return (
    <section className="sec" id="sec-stack">
      <h2 className="sec__label">stack</h2>
      <div className="stackgrid">
        {SKILLS.map(([group, items]) => (
          <div className="sgroup rv" key={group}>
            <b>{group}</b>
            <p>{items}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
